import { Link } from "react-router-dom";

export default function ArticleBreadcrumb({
    article,
}) {
    const category = article.category || [];

    console.log('categories',category);

    return (
        <nav
            className="article-breadcrumb"
            aria-label="breadcrumb"
        >

            <Link to="/">
                خانه
            </Link>

            <span className="article-breadcrumb__separator">
                /
            </span>

            <Link to="/مجله-سلامت">
                مجله
            </Link>

            {category  && (
                <>
                    <span className="article-breadcrumb__separator">
                        /
                    </span>

                    <Link
                        to={`/مجله-سلامت?category=${category.id}`}
                    >
                        {category.title}
                    </Link>
                </>
            )}

            <span className="article-breadcrumb__separator">
                /
            </span>

            <span className="article-breadcrumb__current">
                {article.title}
            </span>

        </nav>
    );
}